import { EDIT_CONTENT_GROUP_SUCCESS } from "fleet/redux-store/content-groups/actions";
import reduceReducers from "reduce-reducers";
import { EDIT_USER_CONTENT_SUCCESS } from "redux-store/user-contents/actions";

import { HIDE_SIDEBAR, SIDEBAR_SET_ACTIVE_KEY } from "./actions";

const initialState = {
  activeKey: null,
  title: "",
  data: {},
  storePath: "",
};

function setSidebarReducer(state = initialState, action) {
  switch (action.type) {
    case SIDEBAR_SET_ACTIVE_KEY:
      return {
        ...state,
        ...action.payload,
      };
    case HIDE_SIDEBAR:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

const hideOnSuccessActions = [
  EDIT_CONTENT_GROUP_SUCCESS,
  EDIT_USER_CONTENT_SUCCESS,
];

function successActionReducer(state = initialState, action) {
  if (hideOnSuccessActions.includes(action.type)) {
    return {
      ...state,
      ...initialState,
    };
  }

  return state;
}

const sidebarReducer = reduceReducers(setSidebarReducer, successActionReducer);

export { initialState, sidebarReducer };
